import { Analytics } from '@segment/analytics-node'

import { CharlieUser } from 'auth/types'

const analytics = new Analytics({
  writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY!,
})

export const SegmentIdentifyAction = (traits: object, user: CharlieUser) => {
  analytics.identify({
    userId: user.teamMemberId!.toString(),
    traits,
  })
}

export const SegmentTrackAction = (
  event: string,
  properties: object,
  user: CharlieUser
) => {
  analytics.track({
    userId: user.teamMemberId!.toString(),
    event,
    properties,
  })
}
